// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Vep+F","list":"style_list__E743A"};